import React from 'react';
import PropTypes from 'prop-types';
import { Box, Text, Flex, GridItem } from '@chakra-ui/react';

import Image from '@repo/ui-components/tailwind/Image';
import BlogExpertBadge from '@repo/ui-components/tailwind/BlogExpertBadge';
import { DeptGrid } from '@repo/ui-components/dept/design-system';
import Link from '@repo/ui-components/tailwind/Link';
import { useUiComponentsInternationalContext } from '@repo/static-translations';

export default function BlogAuthorCard({ author }) {
  const { tt } = useUiComponentsInternationalContext();

  const authorContent = (
    <Box borderRadius="lg" border="1px solid" borderColor="stroke.light" p={4}>
      <Flex gap={4}>
        <Box>
          <Image
            className="rounded"
            sanityImage={author.image}
            srcSetBasisWidth={100}
            width="71px"
          />
        </Box>
        <Box>
          <Text fontWeight="semibold">{author.title}</Text>
          <Text fontWeight="semibold" color="typography.light">
            {author.occupation}
          </Text>
          <BlogExpertBadge className="mt-2" />
        </Box>
      </Flex>
    </Box>
  );

  return (
    <DeptGrid my={10}>
      <GridItem w="302px">
        <Text textStyle="bodyLarge" fontWeight="semibold" mb={2}>
          {tt(s => s.blogAuthorCardComponent.writtenByLabel)}
        </Text>
        {author?.slug?.current ? (
          <Box as={Link} link={`/blog/author/${author?.slug?.current}`}>
            {authorContent}
          </Box>
        ) : (
          authorContent
        )}
      </GridItem>
    </DeptGrid>
  );
}

BlogAuthorCard.propTypes = {
  author: PropTypes.shape({
    image: PropTypes.shape({
      asset: PropTypes.shape({
        url: PropTypes.string,
      }),
      alt: PropTypes.string,
    }),
    title: PropTypes.string,
    occupation: PropTypes.string,
    slug: PropTypes.shape({
      current: PropTypes.string,
    }),
  }).isRequired,
};
